export default {"src":"https://static-cny.howxm.com/_next/static/media/reply.c6e774ed.gif","height":608,"width":1080};